import type { FC } from "react";
import React from "react";

import { NotFoundView } from "@react/foundation/placeholder";

export const NotFoundViewDemo: FC = () => <NotFoundView />;
